module.exports = __webpack_public_path__ + "static/media/settings.f1d175b5.svg";